
import { AnaColumn } from "../forms-template.service";
import { patternString } from "./patternString";
import { SettingGrid, createGridConfig, gridDetail, gridEditable, gridMultiple, gridSimple } from "./gridSettings/gridSettings";
import { DynamicSelectComponent } from "../../components/dynamic-select/dynamic-select.component";
import { environment } from "../../../environments/environment";

const colonneSoggetto = [
  {
    dataField: 'ragioneSociale',
    dataType: 'string',
    caption: 'Ragione sociale',
    allowEditing: true,
    colWidth: '300',
  },
  {
    dataField: 'codiceFiscale',
    dataType: 'string',
    caption: 'Codice Fiscale',
    colWidth: '110',
    type: 'campo',
  },
  {
    dataField: 'partitaIva',
    dataType: 'string',
    colWidth: '110',
    caption: 'Partita Iva',

    type: 'campo',
  },
  {
    dataField: 'comune',
    colWidth: '240',
    caption: 'Località',
    type: 'campo',
    dataType: 'string',
  },
  {
    dataField: 'indirizzo',
    colWidth: '210',
    caption: 'Indirizzo',
    type: 'campo',
    dataType: 'string',
  },
]

const colonneSede = [
  /*  {
     dataField: 'tipoAttività',
     dataType: '',
     caption: '',
     allowEditing: true,
     colWidth: '60',
   }, */
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '200',
  },
  {
    dataField: 'comune',
    dataType: '',
    caption: 'Località',
    allowEditing: true,
    colWidth: '100',
  },
  {
    dataField: 'indirizzo',
    dataType: '',
    caption: 'Indirizzo',
    allowEditing: true,
    colWidth: '100',
  },
]



const genericDescrizioneCodice = [
  {
    dataField: 'id',
    dataType: '',
    caption: 'Codice',
    allowEditing: false,
    colWidth: '60'
  },
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: false,
    colWidth: '540'
  },
]
const genericDescrizione = [
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: false,
    colWidth: '540'
  },
]
const settingGridGeneric: SettingGrid = {
  masterKey: 'id',
  keyUnique: '',
  mode: null,
  selectionMode: 'single',
  remoteOperations: true,
  hoverStateEnabled: true,
  rowAlternationEnabled: true,
  repaintChangesOnly: true,
  showFilterSearch: false,
  allowUpdating: false,
  allowDeleting: false,
  allowAdding: false,
  height: 630,
  showColBlank: false,
  colonne: [
    {
      dataField: 'id',
      dataType: '',
      caption: 'Codice',
      allowEditing: true,
      colWidth: '60px'
    },
    {
      dataField: 'descrizione',
      dataType: '',
      caption: 'Descrizione',
      allowEditing: true,
      colWidth: '560px'
    },
  ],

}
//---------------------------------------------------------------
export const movimentiRifiutiPerStatisticaMensile: AnaColumn[] = [
  {
    itemType: "group", colCount: "2", colSpan: "2",
    data: [{
      type: 'campo',
      dataField: "xt",
      dataType: "string",
      caption: " ",
      orderGriglia: 1,
      colWidth: 350,
      //columnMinWidth:350,  
      allowFiltering: false,
      colVisible: true
    },
    {
      type: 'campo',
      format: environment.PRECISION,
      dataField: "quantitaKg",
      dataType: "number",
      colAlignment: "right",
      caption: "Kg",
      colWidth: 70,
    },
    ]
  }
]
export const movimentiRifiutiPerStatistica: AnaColumn[] = [
  {
    itemType: "group", colCount: "2", colSpan: "2",
    data: [
      /*{type:'campo', dataField: "gruppo", dataType:"" , caption:"Grss.",groupIndex:0,
       colCaption:'provolino'
     },*/
      {
        type: 'campo',
        dataField: "xtotale",
        dataType: "string",
        caption: "xtotale",
        //orderGriglia:1,
        colWidth: 350,
        //columnMinWidth:350,  
        allowFiltering: false,
        colAlignment: 'right',
        colVisible: true
      },
      {
        type: 'campo',
        dataField: "xt",
        dataType: "string",
        caption: "XT",
        orderGriglia: 1,
        colWidth: 350,
        //columnMinWidth:350,  
        allowFiltering: false,
        colVisible: true
      },
      {
        type: 'campo',
        dataField: "xtt",
        dataType: "string",
        caption: "xtt",
        orderGriglia: 1,
        colWidth: 350,
        //columnMinWidth:350,  
        allowFiltering: false,
        colVisible: true
      },
      {
        type: 'campo',
        dataField: "x0",
        dataType: "string",
        caption: "x0",
        orderGriglia: 1,
        colWidth: 350,

        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "x1",
        dataType: "string",
        colAlignment: 'right',
        caption: "x1",
        colWidth: 350,
        orderGriglia: 2,
        colVisible: false,
        allowFiltering: false,
        columnMinWidth: 350
      },
      {
        type: 'campo',
        dataField: "x2",
        dataType: "string",
        caption: "x2",
        colAlignment: 'right',
        colWidth: 350,
        orderGriglia: 3,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "x3",
        dataType: "string",
        colAlignment: 'right',
        caption: "x3",
        colWidth: 350,
        orderGriglia: 3,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "x4",
        dataType: "string",
        caption: "x4",
        colAlignment: 'right',
        colWidth: 350,
        orderGriglia: 3,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "x5",
        dataType: "string",
        caption: "x5",
        colAlignment: 'right',
        colWidth: 350,
        orderGriglia: 3,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "x6",
        colAlignment: 'right',
        dataType: "string",
        caption: "x6",
        colWidth: 350,
        orderGriglia: 3,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "x7",
        colAlignment: 'right',
        dataType: "string",
        caption: "x7",
        colWidth: 350,
        orderGriglia: 3,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "x8",
        dataType: "string",
        colAlignment: 'right',
        caption: "x8",
        colWidth: 350,
        orderGriglia: 3,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "x9",
        dataType: "string",
        colAlignment: 'right',
        caption: "x9",
        colWidth: 350,
        orderGriglia: 3,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm0",
        dataType: "string",
        colAlignment: 'right',
        caption: "Gennaio",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm1",
        dataType: "string",
        colAlignment: 'right',
        caption: "Febbraio",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm2",
        dataType: "string",
        colAlignment: 'right',
        caption: "Marzo",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm3",
        dataType: "string",
        colAlignment: 'right',
        caption: "Aprile",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm4",
        dataType: "string",
        colAlignment: 'right',
        caption: "Maggio",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm5",
        dataType: "string",
        colAlignment: 'right',
        caption: "Giugno",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm6",
        dataType: "string",
        colAlignment: 'right',
        caption: "Luglio",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm7",
        dataType: "string",
        colAlignment: 'right',
        caption: "Agosto",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm8",
        dataType: "string",
        colAlignment: 'right',
        caption: "Settembre",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm9",
        dataType: "string",
        colAlignment: 'right',
        caption: "Ottobre",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm10",
        dataType: "string",
        colAlignment: 'right',
        caption: "Novembre",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "xm11",
        dataType: "string",
        colAlignment: 'right',
        caption: "Dicembre",
        colWidth: 350,
        allowFiltering: false,
        colVisible: false
      },

      {
        type: 'campo',
        dataField: "produttore_Descrizione_Con_Indirizzo_Full",
        dataType: "string",
        caption: "Produttore",

        cellTemplate: true,
        width: "200px",
        colVisible: false

      },
      //trasportatore_Descrizione_Full
      {
        type: 'campo',
        dataField: "trasportatore_Descrizione_Full",
        dataType: "string",
        caption: "Trasportatore Full",

        colVisible: false
      },

      {
        type: 'campo',
        dataField: "trasportatore_Descrizione_Soggetto",
        dataType: "string",
        caption: "Trasportatore A",

        colVisible: false
      },
      {
        type: 'campo',
        dataField: "idTrasportatore",
        dataType: "string",
        caption: "Id Trasportatore A",
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "datiCompletiProduttore",
        dataType: "string",
        caption: "Dati Produttore",
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "datiCompletiTrasportatore",
        dataType: "string",
        caption: "Dati Trasportatore",
        //colWidth:200,   
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "datiCompletiDestinatario",
        dataType: "string",
        caption: "Dati Destinatario",
        //colWidth:200, 
        colVisible: false
      },
      {
        type: 'campo',
        dataField: "trasportatore_Descrizione_Sede",
        dataType: "string",
        caption: "Trasportatore",

        colVisible: false
      },
      {
        type: 'campo',
        dataField: "destinatario_Descrizione_Sede",
        dataType: "string",
        caption: "Smaltitore",

        colVisible: false
      },

      {
        type: 'campo',
        dataField: "causale_Descrizione",
        dataType: "string",
        caption: "Operazione",

        colVisible: false,
      },
      //
      {
        type: 'campo',
        dataField: "idOperazioneRD",
        dataType: "string",
        caption: "Mod.",

        colVisible: false,
      },
      {
        type: 'campo',
        dataField: "dataRegistrazione",
        dataType: 'date',
        caption: "Data Reg.",
        colVisible: false
      },
      {
        dataType: 'date',
        type: 'campo', // il tipo di campo del form
        dataField: "dataFormulario", // l'identificativo univoco del campo
        caption: "Data Fir",
        colVisible: false,
        colWidth: 300,
      },
      {
        dataType: 'string',
        type: 'campo', // il tipo di campo del form
        dataField: "numeroFormulario", // l'identificativo univoco del campo
        caption: "Nr. Fir",
        colVisible: false
      },
      //
      {
        type: 'campo',
        mask: "000000",
        dataField: "eer",
        dataType: "string",
        colWidth: 100,
        caption: "EER",
      },
      /*  "riferimentoEER": "",
            "idStatoFisico": "2",*/
      {
        type: 'campo',
        dataField: "idStatoFisico",
        dataType: "string",
        caption: "S.F.",
        colWidth: 50,
      },
      {
        type: 'campo',
        dataField: "riferimentoEER",
        dataType: "string",
        caption: "Riferimento",
        colWidth: 150,
      },
      //descrizioneAssegnata
      {
        type: 'campo',
        dataField: "descrizioneAssegnata",
        dataType: "string",
        colWidth: 300,
        caption: "Descrizione EER",

      },
      {
        type: "campo",
        dataField: "xSeCarico",
        colVisible: false
      },
      /*{
        type: 'campo', 
         mask: "000000", 
         format: '#####0.###',
         dataField: "quantitaKg",
         dataType: "number",
         colAlignment:"right",
         caption: "Quantita",         
      },*/

      {
        type: 'campo', colVisible: true, colSpan: "3",
        colAlignment: 'right',
        tipoTotale: 'sum',
        dxoSummary: {
          summaryType: 'sum',
          showInGroupFooter: true,
          alignByColumn: true,
          valueFormat: environment.PRECISION,
          displayFormat: "Totale: {0}",
          alignment: 'right'
        },
        //format:environment.PRECISION,

        dataField: "quantitaKg",
        colWidth: 120,
        caption: "Kg", format: environment.PRECISION,
      },
      {
        type: 'campo',
        format: environment.PRECISION,
        dataField: "quantitaKgPerc",
        dataType: "number",
        colAlignment: "right",
        caption: "%Peso",
        colWidth: 70,
      },
      //{ type: 'campo', orderGriglia:2,colWidth: "75", dataField: "pericoloso", dataType: "boolean", caption: "Pericoloso",trueText:'P', falseText:' ', showEditorAlways:false },
    ]
  },
]


//---------------------------------------------------------------
export const statisticheRifiuti: AnaColumn[] = [
  {

    configuration:
    {
      titleGriglia: 'Statistiche Rifiuti',
      titleForm: '$statisticheRifiuti',
      breadcrumbCaption: 'Statistiche Rifiuti',
      campoTitle: ['statisticheRifiuti'],
      masterKey: 'id',
      service: 'statisticheRifiuti',
      startTemplate: 'grid',
      allowedAdvancedFilter: true,
      isAdvancedXlsExportAvailable: true,
      filterEditor: '/$',
      formType: 'simple',
      nCol: 2,
      toolbarSettings: {
        service: 'statisticheRifiuti',

      }

    },


  },

  {
    itemType: "group", groupDataField: 'secondoGruppo', class: "p-1", colCount: 5, colSpan: 2, data: [
      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'causali',
        //odataType:'select',
        //odataFilter:'in',
        class: 'statImpostazioni',
        nCol: 2,
        height: 230,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idCausale',
        caption: 'Causali',

        lista: {
          related: ['idCausale'],

          Async: false,
          dataSource: 'CausaleRifiuti',
          valueExpr: 'id',
          queryString: '?$filter=(isExistsPosizione eq true)',
          displayExpr: 'descrizione',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          //tipoSelect:'odata',
          // labelSelect:'Solo causali operazioni2',
        },
      },

      {
        type: 'campo',
        dataField: 'soloPosizioni',
        editorType: 'dxSelectBox',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idPosizioneRifiuto',
        labelVisible: false,
        caption: 'Posizioni',
        class: 'statImpostazioni',
        nCol: 2,
        height: 230,
        lista: {
          related: ['idPosizioneRifiuto'],//
          dataSource: 'PosizioneRifiuti',
          valueExpr: 'id',
          filter: '?$orderby=descrizione asc',
          //queryString:'?$orderby=Descrizione asc', da sistemare
          displayExpr: 'descrizione',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          tipoSelect: 'multiple',
          labelSelect: 'Solo Posizione',
        },
      },
      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'tipoStatistica',
        class: 'statImpostazioni',
        caption: 'Tipo Statistica',
        nCol: 2,
        height: 230,
        lista: {
          dataSource: 'statistica',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          isMultiple: true,
          tipoSelect: 'single',
          showSelectionControls: true,
          labelSelect: 'Statistica',
        },
      },
      {
        type: 'campo',
        class: 'statImpostazioni',
        editorType: 'dxSelectBox',
        labelVisible: false,
        caption: 'Raggruppa/Ordina per',
        dataField: 'statisticaTipoRaggruppamento',
        nCol: 2,
        height: 230,
        lista: {
          dropEnabled: true,
          dragEnabled: true,
          dataSource: 'statisticaTipoRaggruppamento',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          isMultiple: true,
          labelSelect: 'Raggruppa per',
          tipoSelect: 'multiple',
          showSelectionControls: true,
        },
      },


      //statisticaFiltroMovimenti
      {
        type: 'campo',
        class: 'statImpostazioni',
        editorType: 'dxSelectBox',
        caption: 'Opzioni di stampa',
        labelVisible: false,
        dataField: 'statisticaFiltroMovimenti',
        nCol: 2,
        height: 230,
        lista: {

          dataSource: 'statisticaFiltroMovimenti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          isMultiple: true,
          labelSelect: 'Raggruppa per',
          tipoSelect: 'single',
          showSelectionControls: true,
        },
      },

    ]
  },

  /*
    {
      itemType: "group", class: "p-1", colCount:5,colSpan:2, data: [
        {
          
            type: 'campo',
            editorType:'dxSelectBox',
            labelVisible:false,
            nCol:2,
            lista: {
              dataSource: 'Zona',
              valueExpr: '',
              queryString:'?nomeTabella=Sedi',
              displayExpr: 'causale_Descrizione',
              static: false,
              isMultiple:true,
              tipoSelect:'odata',
              labelSelect:'Solo categ. docum. (da stabilire)',
            },
          },
          {
          
            type: 'campo',
            caption: 'Seleziona Comune',
            editorType:'dxSelectBox',
            labelVisible:false,
            nCol:2,
            lista: {
              dataSource: 'Zona',
              valueExpr: '',
              queryString:'?nomeTabella=Sedi',
              displayExpr: 'descrizione',
              static: false,
              isMultiple:true,
              tipoSelect:'odata',
              labelSelect:'Solo zone racc. (da stabilire)',
            },
          },
          {
          
            type: 'campo',
            editorType:'dxSelectBox',
            labelVisible:false,
            nCol:2,
            lista: {
              dataSource: 'Zona',
              valueExpr: 'id',
              queryString:'?nomeTabella=Sedi',
              displayExpr: 'categoriaDocumento_Descrizione',
              static: false,
              isMultiple:true,
              tipoSelect:'odata',
              labelSelect:'Solo categ. docum. (da stabilire)',
            },
          },
          {
            type: 'campo',
            caption: 'Seleziona Comune',
            editorType:'dxSelectBox',
            labelVisible:false,
            nCol:2,
            lista: {
              dataSource: '',
              valueExpr: '',
              displayExpr: '',
              static: false,
              staticOptions:'selezione',
              isMultiple:true,
              labelSelect:'Selezione',
              tipoSelect:'static',
            },
          },
          {
            type: 'campo',
            caption: 'Seleziona Comune',
            editorType:'dxSelectBox',
            labelVisible:false,
            nCol:2,
            lista: {
              dataSource: '',
              valueExpr: '',
              displayExpr: '',
              static: false,
              staticOptions:'altro',
              isMultiple:true,
              labelSelect:'Altro',
              tipoSelect:'static',
            },
          },
      ]
    },
  */
  {
    itemType: "group", groupDataField: 'filtroGruppo', class: "p-1", colCount: 3, caption: 'Configurazioni', data: [

      {
        colSpan: '1', colVisible: false,
        nCol: 1,
        editorType: '', dataField: 'desdds',
        hideInput: true, type: 'campoDesc',
        class: 'badge',
        visible:false,
        defaultValue: "Documento"
      },
      {
        colSpan: 3,
        type: 'empty', // il tipo di campo del form
      },
      {
        width: 150,
        type: 'campoData', // il tipo di campo del form
        dataField: "daData", // l'identificativo univoco del campo
        caption: "Da Data",
        odataType: 'date',
        odataFilter: '>=',
        dataType: 'date',
        editorType: "dxDateBox",
        format: "dd-MM-yyyy",
        nCol: 3,
      },
      {
        width: 100,
        labelWidth: 100,
        type: 'campoData', // il tipo di campo del form
        dataField: "aData", // l'identificativo univoco del campo
        caption: "A Data",
        odataType: 'date',
        odataFilter: '<=',
        dataType: 'date',
        editorType: "dxDateBox",
        format: "dd-MM-yyyy",
        nCol: 3,
      },
      {
        width: 210,
        labelWidth: 100,
        dataType: 'string',
        type: 'campo', // il tipo di campo del form
        dataField: "numeroFormulario", // l'identificativo univoco del campo
        caption: "Formulario",
        odataFilter: 'contains',
        odataType: 'string',
        nCol: 4,
        // il classico span di html
      },
      {
        width: 210,
        type: 'campo', // il tipo di campo del form
        dataField: "riferimentoDocumento", // l'identificativo univoco del campo
        caption: "Rif. Documento",
        dataType: 'string',
        odataFilter: 'contains',
        odataType: 'string',
        staticDataField: 'riferimentoDocumento',
        nCol: 3,

        // il classico span di html
      },
      {
        width: 210,
        labelWidth: 100,
        type: 'campo', // il tipo di campo del form
        dataField: "scontrino", // l'identificativo univoco del campo
        caption: "Scontrino",

        nCol: 3,
        // il classico span di html
      },
      {
        width: 210,
        labelWidth: 100,
        type: 'campo', // il tipo di campo del form
        dataField: "tipologia", // l'identificativo univoco del campo
        caption: "Tipologia",
        nCol: 4,
        // odataFilter:'contains',
        dataType: 'string',
        // il classico span di html
      },

      { //categoriaDocumento ok
        type: 'campoSpecial',
        dataField: "idCategoriaDocumento", caption: "Categorie Doc.",
        colVisible: true,
        width: '100',
        nCol: '10',
        hideOnEdit: false,
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idCategoriaDocumento',
        dynamic: {
          dataSource: 'Categoria',
          service: 'generic',
          autocomplete: false,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          caption: "Categoria docX.",
          queryString: '?nomeTabella=movimenti',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Categorie Documenti',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie Documenti',
            name: 'categorieDoc',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridMultiple,
            colonne: genericDescrizione
          }),
        }
      },
      {

        colSpan: 3,
        type: 'empty', // il tipo di campo del form
        dataField: "ff", // l'identificativo univoco del campo
        // il classico span di html
      },

      { //TipiDocumento ok
        type: 'campoSpecial',
        dataField: "idTipoDocumento", caption: "Tipo Doc.",
        colVisible: true,
        width: '100',
        colCount: "5",
        nCol: '10',
        hideOnEdit: false,
        disableOnUpdate: true,
        odataFilter: 'in',
        odataType: 'select',
        staticDataField: 'idTipoDocumento',
        dynamic: {
          dataSource: 'Tipo',
          service: 'generic',
          autocomplete: false,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          caption: "Tipo docX.",
          queryString: '?nomeTabella=movimenti',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Categorie Documenti',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie Documenti',
            name: 'categorieDoc',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridMultiple,
            colonne: genericDescrizione
          }),
        }
      },
      {

        colSpan: 3,
        type: 'empty', // il tipo di campo del form
        dataField: "ff", // l'identificativo univoco del campo
        // il classico span di html
      },
      { //ZonaDocumento ok
        type: 'campoSpecial',
        dataField: "idZonaDocumento", caption: "Zona Doc.",
        colVisible: true,
        width: '100',
        nCol: '10',
        hideOnEdit: false,
        disableOnUpdate: true,
        odataFilter: 'in',
        odataType: 'select',
        staticDataField: 'idZonaDocumento',
        dynamic: {
          dataSource: 'Zona',
          service: 'generic',
          autocomplete: false,
          displayExpr: 'descrizione',
          valueExpr: 'id',
          caption: "Tipo docX.",
          queryString: '?nomeTabella=movimenti',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Categorie Documenti',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie Documenti',
            name: 'categorieDoc',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridMultiple,
            colonne: genericDescrizione
          }),
        }
      },
      {

        colSpan: 3,
        type: 'empty', // il tipo di campo del form
        dataField: "ff", // l'identificativo univoco del campo
        // il classico span di html
      },

      {
        colSpan: '13', colVisible: false,
        nCol: 1,
        editorType: '', dataField: 'desdds',
        hideInput: true, type: 'campoDesc',
        class: 'badge',
        defaultValue: "EER",
        visible:false,
      },
      {
        colSpan: 3,
        type: 'empty', // il tipo di campo del form
      },

      // IMPOSTAZIONI SU EER

      {
        width: 210,
        //labelWidth: 80,
        type: 'campo', // il tipo di campo del form
        dataField: "eer", // l'identificativo univoco del campo
        caption: "EER",
        nCol: 3,
        odataFilter: 'contains',
        odataType: 'string',
        // START EER ---------------------------------------
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'cer'+"?$filter=(not endswith(id,'00'))",
          service: '',
          autocomplete: false,
          caption: "Lista EER",
          filterStatic: "?$filter=(not endswith(id,'00'))",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista EER',
            name: 'EER',
            location: 'after',
          },
          settingGrid: settingGridGeneric
        },
        // END EER --------------------------------------
      },
      {
        
        width: 210,
        labelWidth: 100,
        type: 'campo', // il tipo di campo del form
        dataField: "riferimentoEER", // l'identificativo univoco del campo
        caption: "Rif.",
        nCol: 3,
        odataFilter: 'contains',
        odataType: 'string',
        showClearButton:true,
        // il classico span di html
      },

      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "SF",
        width: '20',
        labelWidth: 100,
        colWidth: '40',
        colVisible: false,
        labelVisible: true,
        nCol: '4',
        orderGriglia: 9,
        class: 'stato-fisico',
        showClearButton: false,
        maxLength: '2',
        odataFilter: 'in',
        odataType: 'select',
        // staticDataField:'isStatoFisico',       
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: '',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista StatoFisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: settingGridGeneric
        },
      },



      {

        colSpan: 3,
        type: 'empty', // il tipo di campo del form
        dataField: "ff", // l'identificativo univoco del campo
        // il classico span di html
      },

      {
        width: 30,
        type: 'campo', // il tipo di campo del form
        dataField: "quantitaKg", // l'identificativo univoco del campo
        caption: "solo peso >0",
        nCol: 2,
        editorType: 'dxCheckBox',
        odataFilter: '=',
        odataType: 'boolean',
        // il classico span di html
      },
      {
        width: 50,
        type: 'campo', // il tipo di campo del form
        dataField: "solokguguali", // l'identificativo univoco del campo
        caption: "solo peso =0",
        nCol: 2,
        editorType: 'dxCheckBox',
        odataFilter: '=',
        odataType: 'boolean',
        // il classico span di html
      },
      {
        type: 'empty', // il tipo di campo del form
        dataField: "", // l'identificativo univoco del campo

        // il classico span di html
      },
      {
        colSpan: '2', colVisible: false,
        nCol: 1,
        width: 100,
        labelWidth: 100,
        editorType: '', dataField: 'desdd',
        hideInput: true, type: 'campoDesc',
        class: 'badge',
        visible:false,
        defaultValue: "Inizio Trasp."
      },
      {
        colSpan: 3,
        type: 'empty', // il tipo di campo del form
      },
      {
        width: 100,
        labelWidth: 100,
        type: 'campoData', // il tipo di campo del form
        dataField: "daDataTrasporto", // l'identificativo univoco del campo
        caption: "Trasp. Da Data",
        dataType: 'date',
        editorType: "dxDateBox",
        format: "dd/MM/yyyy",
        nCol: 3,
        odataType: 'date',
        odataFilter: '>=',
      },

      {
        width: 100,
        labelWidth: 100,
        nCol: 3,
        type: 'campoData', // il tipo di campo del form
        dataField: "aDataTrasporto", // l'identificativo univoco del campo
        caption: "A Data",
        dataType: 'date',
        editorType: "dxDateBox",
        format: "dd/MM/yyyy",
        odataType: 'date',
        odataFilter: '<=',
      },
      {
        type: 'empty', // il tipo di campo del form
        dataField: "", // l'identificativo univoco del campo

        // il classico span di html
      },

    ]
  },
  {
    itemType: "group", groupDataField: 'sceltaProduttore', class: "p-1", colCount: 4, caption: 'Configurazioni', data: [
      {
        colSpan: '4', colVisible: false,
        nCol: 10,
        editorType: '', dataField: 'desdds',
        hideInput: true, type: 'campoDesc',
        class: 'badge',
        defaultValue: "Produttore",
        visible:false,

      },



      {
        type: 'campoSpecial', dataField: "produttore_Descrizione_Soggetto", dataType: "", caption: "Prod./Detent.",
        colVisible: false,
        disableOnUpdate: true,
        nCol: '5',
        placeHolder: '',
        editorType: 'dxTextBox',
        class: 'disabled-soggetti sfondo',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_Id_Soggetto',
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Aziende Produttrici",
          queryString: '?TipoAttivita=P',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|produttore_Id_Soggetto', 'nsAzienda', 'descrizione|produttore_Descrizione_Sede', 'id|idProduttore'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isProduttore eq true)',

          }

        }
      },
      {
        type: 'campoSpecial', dataField: "produttore_Descrizione_Sede",
        dataType: "",
        caption: "U.L.",
        colVisible: false,
        disableOnUpdate: true,
        placeHolder: '',
        disabled: true,

        nCol: '4',
        labelWidth: 55,
        class: 'disabled-soggetti',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idProduttore',
        /*  placeHolder: 'Digita la ragione sociale o il nome dell\'unità locale di produzione', */
        dynamic: {
          dataSource: "sede",
          service: 'sede',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Unica locali produttore",
          costantValue: [{
            key: 'produttore_Id_Soggetto',
            value: 'produttore_Id_Soggetto'

          }],
          queryString: '/$produttore_Id_Soggetto?$filter=(isProduttore eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idProduttore'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),



        }
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoProduttori",
        nCol: 'auto',
        dataType: "",
        caption: "addElencoProduttori",
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: '',
          name: 'addElencoProduttori',
          location: 'after',
          disabled: false,
          event: "addDati",
          hint: "mostra e gestisci gruppi produttori",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,
        }
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "cancElencoProduttori",
        nCol: 'auto',
        dataType: "",
        caption: "cancElencoProduttori",
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: '',
          name: 'cancElencoProduttori',
          location: 'after',
          disabled: false,
          event: "cancDati",
          hint: "cancella i filtri impostati",
          icon: "glyphicon mdi mdi-delete",
          outPutValue: false,
        }
      },




      //------------------------------- End Produttore -------------------------------

      {
        type: 'campoSpecial', // il tipo di campo del form
        dataField: "autorizzazione", // l'identificativo univoco del campo
        caption: "AutorizA.",
        disableOnUpdate: true,
        readonly: true,
        disabled: true,
        autoClear: true,
        showClearButton: true,
        editorType: 'dxTextBox',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutorizzazioneProduttore',
        nCol: '5',
        dynamic: {
          related: ['id|idAutorizzazioneProduttore'],
          costantValue: [{
            key: 'idProduttore',
            value: 'idProduttore'

          }],
          //displayExpr: 'numero',
          displayExpr: 'descrizione',
          dataSource: "Autorizzazione",
          service: "autorizzazione",
          valueExpr: '',
          autocomplete: true,

          static: false,
          caption: "Elenco Autorizzazioni.",
          queryString: "/$idProduttore",
          componentType: 'dynamicGrid',
          buttonOption: {
            //   
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimor.',
            name: 'rimor',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream

          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'id',
                caption: 'Codice.',
                width: 25,
                dataType: "",
              },
              {
                dataField: 'descrizione',
                caption: 'Descrizione',

                dataType: "",
              },
            ]
          }
        }
      },

      {
        type: 'campoSpecial', dataField: "idMagazzinoProduttore", dataType: "", caption: "Magaz1.",
        // colVisible: false,
        showClearButton: true,
        labelVisible: true,
        disabled: true,
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idMagazzinoProduttore',
        nCol: '4',

        // class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        //disableOnUpdate: true,
        dynamic: {
          costantValue: [{
            key: 'idProduttore',
            value: 'idProduttore'

          }],
          queryString: "?idSede=$idProduttore",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: true,
          valueExpr: 'id',
          caption: "Lista Magazzini unità locale",

          related: ['id|idMagazzinoProduttore'],
          searchOptions: {
            service: 'magazzinorifiuti',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idMagazzinoProduttore'],


          },

          buttonOption: {
            text: 'magazzinoProduttore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista magazzinoi del soggetto selezionato',
            name: 'magazzinoProduttore',
            location: 'after',

          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  dataField: 'id',
                  caption: 'Codice.',
                  width: 25,
                  dataType: "",
                },
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Magazzino',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {

        type: 'empty', // il tipo di campo del form
      },
      {

        type: 'empty', // il tipo di campo del form
      },
      {
        type: 'campoSpecial', dataField: "cantiereProduttore_Descrizione", dataType: "", caption: "Cantiere",
        colVisible: false,
        labelVisible: true,
        disabled: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        nCol: 5,
        colSpan: 4,
        editorClass: 'text-uppercase',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idCantiereFuoriUl',
        class: '',
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idProduttore?$filter=(isSospeso ne true)",
          displayExpr: 'descrizione',
          dataSource: "Cantiere",
          service: 'cantiere',
          autocomplete: false,
          valueExpr: '',
          caption: "Lista Cantieri fuiri unità locale",
          related: ['id|idCantiereFuoriUl'],
          buttonOption: {
            text: 'CantiereFuoriUl',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista dei cantieri del soggetto selezionato',
            name: 'CantiereFuoriUl',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 1000,
            colonne: colonneSede
          }),

        }
      },
      //*********** *TRASPORTATORE* ************************ */
      {
        colSpan: '4', colVisible: false,
        nCol: 10,
        editorType: '', dataField: 'gggg',
        hideInput: true, type: 'campoDesc',
        class: 'badge',
        visible:false,
        defaultValue: "Trasportatore C"
      },


      //***** TRASPORTATORE */
      {
        type: 'campoSpecial', dataField: "trasportatore_Descrizione_Soggetto",
        dataType: "",
        caption: "Trasportatore",
        colVisible: true,
        disableOnUpdate: true,

        nCol: '5',
        class: 'disabled-soggetti sfondo',
        placeHolder: '',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idTrasportatore',
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione',//'descrizioneSoggetto'
          caption: "Lista Aziende Trasportatori",
          queryString: '?TipoAttivita=T',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|trasportatore_Id_Soggetto', 'nsAzienda', 'descrizione|trasportatore_Descrizione_Sede', 'id|idTrasportatore'],
          buttonOption: {
            text: 'Trasportatori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Trasportatori',
            name: 'trasportatore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isTrasportatore eq true)',

          }

        }
      },
      // Autorizzazione (ok)
      {
        nCol: '4',
        type: 'campoSpecial', // il tipo di campo del form
        dataField: "autorizzazioneTrasporsportatore", // l'identificativo univoco del campo
        caption: "Autoriz.",
        disableOnUpdate: true,
        disabled: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutorizzazioneTrasportatore',

        dynamic: {
          related: ['id|idAutorizzazioneTrasportatore'],
          costantValue: [{ key: 'idTrasportatore', value: 'idTrasportatore' },],
          dataSource: 'Autorizzazione',

          queryString: "/$idTrasportatore",
          valueExpr: '',
          autocomplete: true,
          displayExpr: 'descrizione',
          static: false,
          caption: "Elenco Descrizione Soggetto.",

          componentType: 'dynamicGrid',
          buttonOption: {
            //   text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimor.',
            name: 'rimor',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream

          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'id',
                caption: 'Codice.',
                width: 25,
                dataType: "",
              },
              {
                dataField: 'descrizione',
                caption: 'Descrizione',

                dataType: "",
              },
            ]
          }
        }
      },

      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoTrasportatori",
        nCol: 'auto',
        dataType: "",
        caption: "addElencoTrasportatori",
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: '',
          name: 'addElencoTrasportatori',
          location: 'after',
          disabled: false,
          event: "addDati",
          hint: "mostra e gestisci gruppi trasportatori",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,
        }
      },

      {
        type: 'simpleButton', colVisible: false,
        dataField: "cancElencoTrasportatori",
        nCol: 'auto',
        dataType: "",
        caption: "cancElencoTrasportatori",
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: '',
          name: 'cancElencoTrasportatori',
          location: 'after',
          disabled: false,
          event: "cancDati",
          hint: "mostra e gestisci gruppi trasportatori",
          icon: "glyphicon mdi mdi-delete",
          outPutValue: false,
        }
      },




      //????????????????????????????????????????
      // automezzo, rimorchio,rimorchio
      {
        //width: 100,
        nCol: '5',
        type: 'campoSpecial', // il tipo di campo del form
        dataField: "automezzo", // l'identificativo univoco del campo
        caption: "Autom.",
        disableOnUpdate: true,
        disabled: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutomezzo',
        //labelWidth: 90,          
        dynamic: {
          related: ['id|idAutomezzo'],

          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'

          }],
          dataSource: 'Automezzo',
          valueExpr: '',
          autocomplete: false,
          displayExpr: 'targa',
          service: 'automezzo',
          caption: "Elenco Automezzi.",
          queryString: "/$idTrasportatore?$filter=not (tipoautomezzo eq 'D' or tipoautomezzo eq 'E' or tipoautomezzo eq 'F')",
          componentType: 'dynamicGrid',
          buttonOption: {
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Automezzi',
            name: 'sfAutomezzo',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 700,
            colonne: [
              {
                dataField: 'descrizione',
                caption: 'Descrizione',
                dataType: "",
              },
              {
                dataField: 'targa',
                caption: 'Targa',
                dataType: "",
              },

            ]
          }),
        }
      },
      //rimorchio
      {
        nCol: 4,
        type: 'campoSpecial', // il tipo di campo del form
        dataField: "rimorchio", // l'identificativo univoco del campo
        caption: "Rim.",
        disableOnUpdate: true,
        disabled: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idRimorchio',

        //labelWidth: 90,          
        dynamic: {
          related: ['id|idRimorchio'],
          costantValue: [{
            key: 'idTrasportatore',
            value: 'idTrasportatore'

          }],
          dataSource: 'Automezzo',
          valueExpr: '',
          autocomplete: true,
          displayExpr: 'targa',
          static: false,
          caption: "Elenco Automezzi.",
          queryString: "/$idTrasportatore?$filter= (tipoautomezzo eq 'D' or tipoautomezzo eq 'E' or tipoautomezzo eq 'F')",
          componentType: 'dynamicGrid',
          buttonOption: {
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Automezzi',
            name: 'sfAutomezzo',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream

          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'descrizione',
                caption: 'Descrizione',
                dataType: "",
              },
              {
                dataField: 'targa',
                caption: 'Targa',
                dataType: "",
              },

            ]
          }
        }
      },
      {

        type: 'empty', // il tipo di campo del form
      },
      {

        type: 'empty', // il tipo di campo del form
      },
      //autista
      {
        colSpan: 4,
        nCol: '5',
        type: 'campoSpecial', // il tipo di campo del form
        dataField: "autista", // l'identificativo univoco del campo
        caption: "Autista",
        disabled: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutista',

        disableOnUpdate: true,
        //labelWidth: 120,
        dynamic: {
          related: ['id|idAutista'],
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },

          ],

          dataSource: 'Autista',
          valueExpr: '',
          autocomplete: true,
          displayExpr: ['nome', 'cognome'],
          static: false,
          caption: "Elenco Descrizione Matricole.",
          queryString: "/$idTrasportatore",
          componentType: 'dynamicGrid',
          buttonOption: {
            //   text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimor.',
            name: 'rimor',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream

          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'nome',
                caption: 'Nome',
                width: 25,
                dataType: "",
              },
              {
                dataField: 'cognome',
                caption: 'Cognome',
                width: 25,
                dataType: "",
              },
              {
                dataField: 'matricola',
                caption: 'Matricola',

                dataType: "",
              },
            ]
          }
        }
      },
      // ***** *DESTINATARIO
      {
        colVisible: false,
        colSpan: 4,
        nCol: 10,
        editorType: '', dataField: 'desddsd',
        hideInput: true, type: 'campoDesc',
        class: 'badge',
        visible:false,
        defaultValue: "Destinatario"
      },

      // DESTINATARIO *********************************************
      {
        type: 'campoSpecial', dataField: "destinatario_Descrizione_Soggetto",
        dataType: "", caption: "Destinatario",
        colVisible: true,
        disableOnUpdate: true,

        nCol: '5',
        class: 'disabled-soggetti sfondo',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_Id_Soggetto',

        placeHolder: '',
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Destinatari",
          queryString: '?TipoAttivita=S',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|destinatario_Id_Soggetto', 'nsAzienda', 'descrizione|destinatario_Descrizione_Sede', 'id|idDestinatario'],
          buttonOption: {
            text: 'Destinatari',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Destinatari',
            name: 'destinatari',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isDestinatario eq true)',

          }

        }
      },
      {
        type: 'campoSpecial', dataField: "destinatario_Descrizione_Sede",
        dataType: "",
        caption: "U.L.",
        colVisible: false,
        disableOnUpdate: true,
        disabled: true,

        nCol: '4',

        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idDestinatario',

        class: 'disabled-soggetti',
        dynamic: {
          dataSource: "sede",
          service: 'sede',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Unica locali destinatari",
          costantValue: [{
            key: 'destinatario_Id_Soggetto',
            value: 'destinatario_Id_Soggetto'

          }],
          queryString: '/$destinatario_Id_Soggetto?$filter=(isDestinatario eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idDestinatario'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'ulDestinatario',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),



        }
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "addElencoProduttori",
        nCol: 'auto',
        dataType: "",
        caption: "addElencoDestinatari",
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: '',
          name: 'addElencoDestinatari',
          location: 'after',
          disabled: false,
          event: "addDati",
          hint: "mostra e gestisci gruppi destinatari",
          icon: "glyphicon mdi mdi-dots-horizontal",
          outPutValue: false,
        }
      },
      {
        type: 'simpleButton', colVisible: false,
        dataField: "cancElencoDestinatari",
        nCol: 'auto',
        dataType: "",
        caption: "cancElencoDestinatari",
        editorClass: 'nica-plaintext-readonly',

        button: {
          text: '',
          name: 'cancElencoDestinatari',
          location: 'after',
          disabled: false,
          event: "cancDati",
          hint: "mostra e gestisci gruppi destinatari",
          icon: "glyphicon mdi mdi-delete",
          outPutValue: false,
        }
      },
      {

        type: 'empty', // il tipo di campo del form
      },
      {

        type: 'empty', // il tipo di campo del form
      },
      /////////////////////////////////////// 
      {
        type: 'campoSpecial', // il tipo di campo del form
        dataField: "autorizzazioneDestinatario", // l'identificativo univoco del campo
        caption: "Autoriz.",
        disabled: true,
        nCol: 5,
        labelWidth: 90,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idAutorizzazioneDestinatario',

        dynamic: {
          related: ['id|idAutorizzazioneDestinatario'],
          costantValue: [{
            key: 'idDestinatario',
            value: 'idDestinatario'

          }],
          //displayExpr: 'numero',
          displayExpr: 'descrizione',
          dataSource: "Autorizzazione",
          service: "autorizzazione",
          valueExpr: '',
          autocomplete: true,

          static: false,
          caption: "Elenco Autorizzazioni.",
          queryString: "/$idDestinatario",
          componentType: 'dynamicGrid',
          buttonOption: {
            //   
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Rimor.',
            name: 'rimorXX',
            location: 'after', // a destra dell'input in cui ci troviamo in devstream

          },
          settingGrid: {
            campoTabRif: '',
            masterKey: 'id',
            keyUnique: '',
            mode: 'cell',
            selectionMode: 'single', // single indica che puoi selezionare solo valore
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            sortingMode: 'multiple',
            searchAndSelect: false, //Cerca Valore e seleziona
            height: 700,
            showColBlank: false,
            colonne: [
              {
                dataField: 'id',
                caption: 'Codice.',
                width: 25,
                dataType: "",
              },
              {
                dataField: 'descrizione',
                caption: 'Descrizione',

                dataType: "",
              },
            ]
          }
        }
      },

      {
        type: 'campoSpecial', dataField: "magazzinoDestinatario_Descrizione",
        dataType: "", caption: "Magaz.",
        colVisible: false,
        labelVisible: true,
        disabled: true,
        nCol: 4,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idMagazzinoDestinatario',

        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{
            key: 'idDestinatario',
            value: 'idDestinatario'

          }],
          queryString: "?idSede=$idDestinatario",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: true,
          valueExpr: 'id',
          caption: "Lista Magazzini",

          related: ['id|idMagazzinoDestinatario'],
          searchOptions: {
            service: 'magazzinorifiuti',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idMagazzinoDestinatario'],


          },

          buttonOption: {
            text: 'magazzinoDestinatario',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista magazzinoi del soggetto selezionato',
            name: 'magazzinoDestinatario',
            location: 'after',

          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Magazzino',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        colSpan: 2,
        type: 'empty', // il tipo di campo del form
      },
      {
        type: 'campoSpecial', dataField: "cantiereDestinatario_Descrizione", dataType: "",
        caption: "Cantiere",
        colVisible: false,
        labelVisible: true,
        disabled: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idCantiereFuoriUlDestinatario',
        colSpan: 4,
        labelWidth: 90,
        nCol: 5,
        editorClass: 'text-uppercase',
        class: '',
        dynamic: {
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idDestinatario?$filter=(isSospeso ne true)",
          displayExpr: 'descrizione',
          dataSource: "Cantiere",
          service: 'cantiere',
          autocomplete: false,
          valueExpr: '',
          caption: "Lista Cantieri",
          related: ['id|idCantiereFuoriUlDestinatario'],
          buttonOption: {
            text: 'CantiereFuoriUl',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista dei cantieri del soggetto selezionato',
            name: 'CantiereFuoriUlDestinatario',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 1000,
            colonne: colonneSede
          }),

        }
      },

      {
        type: 'campoSpecial', dataField: 'idOperazioneRD', dataType: '',
        colCaption: 'Op.',
        caption: 'Op.smalt/recup.',
        colVisible: false,
        colSpan: 4,
        nCol: '9',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idOperazioneRD',
        labelWidth: 90,
        editorClass: 'text-uppercase',
        dynamic: {
          displayExpr: '',
          dataSource: 'OperazioneSmaltimento',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: 'id',
          caption: "Lista Modalità di smaltimento/recupero",
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'OperazioneRD',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: "'Sfoglia l'elenco delle operazioni di smaltimento",
            name: 'OperazioneRD',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridMultiple,
            colonne: genericDescrizioneCodice
          }),
        }
      },
      {
        colSpan: 3,
        type: 'empty', // il tipo di campo del form
      },
      //////////////////////////////////////////////////

      //*********** *Intermediario* ************************ */
      {
        colSpan: '4', colVisible: false,
        nCol: 10,
        editorType: '', dataField: 'ggggd',
        hideInput: true, type: 'campoDesc',
        class: 'badge',
        visible:false,
        defaultValue: "Itermediario"
      },

      {
        type: 'campoSpecial', dataField: "intermediario_Descrizione_Soggetto",
        dataType: "",
        caption: "Intermedario",
        colVisible: false,
        disableOnUpdate: true,
        colSpan: 4,
        nCol: '9',
        class: 'disabled-soggetti sfondo',
        placeHolder: '',
        odataType: 'select',
        odataFilter: 'in',
        //staticDataField:'intermediario_Id_Soggetto', 

        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizione',//'descrizioneSoggetto'
          caption: "Lista Intermediari",
          queryString: '?TipoAttivita=I',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|intermediario_Id_Soggetto', 'nsAzienda', 'descrizione|indermediario_Descrizione_Sede', 'id|IdIntermediario'],
          buttonOption: {
            text: 'Intermediari',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Intermediari',
            name: 'intermediari',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isIntermediario eq true)',

          }

        }
      },
      {

        colSpan: 3,
        type: 'empty', // il tipo di campo del form
        dataField: "ff", // l'identificativo univoco del campo
        // il classico span di html
      },


    ]
  }
]

export const addElencoProduttoriNO: AnaColumn[] = [
  {
    itemType: "group",
    caption: 'filtri Sede Legale',
    groupDataField: 'quintoGruppo',
    class: "p-1",
    colCount: 2,
    data: [

      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'elencoSoggetti',
        class: 'statImpostazioni',
        nCol: 5,
        height: 230,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'elencoSoggetti',
        caption: 'Prod./Det',
        placeHolder: '',
        lista: {
          Async: false,
          dataSource: 'Soggetto',
          valueExpr: 'id',
          queryString: '?TipoAttivita=P',
          displayExpr: 'ragioneSociale',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          related: ['idSoggetto|produttore_Id_Soggetto']
          //tipoSelect:'odata',
          // labelSelect:'Solo causali operazioni2',
        },
      },

      {
        type: 'campo',
        dataField: 'elencoSedi',
        editorType: 'dxSelectBox',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idProduttore',
        labelVisible: false,
        caption: 'Unita Locali',
        class: 'statImpostazioni',
        nCol: 5,
        height: 230,
        lista: {
          dataSource: 'Sede/GetAllSoggettiSedi',
          valueExpr: 'id',
          queryString: '?$filter=(isproduttore eq true and id gt 0)',
          filter: '',//'?$filter=(isproduttore eq true and id>0)',
          //queryString:'?$orderby=Descrizione asc', da sistemare
          displayExpr: 'descrizione',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          tipoSelect: 'multiple',
          labelSelect: 'Sede Soggetto',
        },
      },


    ]
  },
  {
    itemType: "group", caption: 'filtri su Unità legali', groupDataField: 'produttoreGroup', class: "p-1", colCount: 2, data: [
      {
        type: 'campoSpecial', dataField: "regione_soggetto", dataType: "", caption: "Regione Soggetto",

        colVisible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,

        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|uL_IdRegione'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "regione_sede", dataType: "", caption: "Regione Sede",

        colVisible: false,
        nCol: 5,
        labelWidth: 120,
        disableOnUpdate: false,

        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|uL_IdRegione'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "categoria_descrizione_soggetto_produttori",
        dataType: "", caption: "Categorie Soggetto",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 130,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=Sedi",
          filterStatic: "",

          displayExpr: 'descrizione',
          dataSource: "Categoria",
          service: 'categoria',
          autocomplete: true,
          valueExpr: '',
          caption: "Categorie",

          searchOptions: {
            service: 'categoria',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'categoria',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Categoria',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "categoria_descrizione_sedi_produttori",
        dataType: "", caption: "Categorie Sedi",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 120,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=SOGGETTI",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Categoria",
          service: 'categoria',
          autocomplete: true,
          valueExpr: '',
          caption: "Categorie",

          searchOptions: {
            service: 'categoria',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'categoria',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Categoria',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "descrizione_zona_produttori_soggetto",
        dataType: "", caption: "Zona Soggetto",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 130,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=SOGGETTI",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Zona",
          service: 'zona',
          autocomplete: true,
          valueExpr: '',
          caption: "Zone",

          searchOptions: {
            service: 'zone',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'zone',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Zone',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "descrizione_zona_produttori_sede",
        dataType: "", caption: "Zona Sedi",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 120,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=Sedi",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Zona",
          service: 'zona',
          autocomplete: true,
          valueExpr: '',
          caption: "Zone",

          searchOptions: {
            service: 'zone',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'zone',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Zone',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
    ]
  }
]


export const addElencoProduttori: AnaColumn[] = [
  {
    itemType: "group",
    caption: 'filtri Sede Legale',
    groupDataField: 'quintoGruppo',
    class: "p-1",
    colCount: 2,
    data: [

      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'ragioneSociale',
        //odataType:'select',
        //odataFilter:'in',
        class: 'statImpostazioni',
        nCol: 5,
        height: 230,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_Id_Soggetto',
        caption: 'Produ./Det',
        placeHolder: '',
        
        lista: {
          Async: false,
          dataSource: 'Soggetto',        
          valueExpr: 'id',
          queryString: '?TipoAttivita=P',
          displayExpr: 'ragioneSociale',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          related: ['idSoggetto|produttore_Id_Soggetto'],
          //tipoSelect:'odata',
          // labelSelect:'Solo causali operazioni2',
        },
      },

      {
        type: 'campo',
        dataField: 'produttore_sede',
        editorType: 'dxSelectBox',
        odataType: 'select',
        odataFilter: 'eq',
        staticDataField: 'idProduttore',
        labelVisible: false,
        caption: 'Produttore Sede',
        class: 'statImpostazioni',
      
        nCol: 5,
        height: 230,
        lista: {
          dataSource: 'Sede/GetAllSoggettiSedi',
          valueExpr: 'id',
          queryString: '?$filter=(isproduttore eq true and id gt 0 and id ne null)&$orderby=Descrizione asc',
          filter: '',//'?$filter=(isproduttore eq true and id>0)',
          //queryString:'?$orderby=Descrizione asc', da sistemare
          displayExpr: 'descrizione',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          tipoSelect: 'multiple',
          labelSelect: 'Sede Soggetto',
         
        },
      },


    ]
  },
  {
    itemType: "group", caption: 'filtri su Unità legali', groupDataField: 'produttoreGroup', class: "p-1", colCount: 2, data: [
      {
        type: 'campoSpecial', dataField: "regione_soggetto_produttore", dataType: "", caption: "Regione Soggetto",

        colVisible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        //odataType:'select',
        // odataFilter:'in',
        // staticDataField:'regione_soggetto',        
        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|produttore_Id_Regione_Soggetto'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "produttore_Id_Regione_Soggetto", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_Id_Regione_Soggetto',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "regione_sede_produttore", dataType: "", caption: "Regione Sede",
        colVisible: false,
        nCol: 5,
        labelWidth: 120,
        disableOnUpdate: false,

        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|produttore_Id_Regione_Sede'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "produttore_Id_Regione_Sede", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_Id_Regione_Sede',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "produttore_IdCategoria_Soggetto ",
        dataType: "", caption: "Categorie Soggetto",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        staticDataField: 'produttore_IdCategoria_Soggetto',
        labelWidth: 130,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,

        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|produttore_IdCategoria_Soggetto'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],

          queryString: "?nomeTabella=soggetti",
          filterStatic: "",

          displayExpr: 'descrizione',
          dataSource: "Categoria",
          service: 'categoria',
          autocomplete: true,
          valueExpr: '',
          caption: "Categorie",

          searchOptions: {
            service: 'categoria',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id_categoria_produttori'],


          },

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'categoria',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Categoria',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "produttore_IdCategoria_Soggetto", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,

        odataType: 'select',
        odataFilter: 'in',
        //staticDataField: 'produttore_IdCategoria_Soggetto',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "categoria_descrizione_sedi_produttori",
        dataType: "", caption: "Categorie Sedi",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 120,
        staticDataField: 'id_categoria_sedi_produttori',
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,

        dynamic: {
          related: ['id|produttore_IdCategoria_Sede'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=Sedi",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Categoria",
          service: 'categoria',
          autocomplete: true,
          valueExpr: '',
          caption: "Categorie",

          searchOptions: {
            service: 'categoria',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idCategoriaSedi'],


          },

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'categoria',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Categoria',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "idCategoriaSedi", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_IdZona_Soggetto',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "descrizione_zona_produttori_soggetto",
        dataType: "", caption: "Zona Soggetto",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 130,

        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['id|produttore_IdZona_Soggetto'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=SOGGETTI",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Zona",
          service: 'zona',
          autocomplete: true,
          valueExpr: '',
          caption: "Zone",

          searchOptions: {
            service: 'zone',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idZona_produttore'],


          },

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'zone',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Zone',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "produttore_IdZona_Soggetto", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_IdZona_Soggetto',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "descrizione_zona_produttori_sede",
        dataType: "", caption: "Zona Sedi",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 120,

        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['id|produttore_IdZona_Sede'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=Sedi",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Zona",
          service: 'zona',
          autocomplete: true,
          valueExpr: '',
          caption: "Zone",

          searchOptions: {
            service: 'zone',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idZona_produttori_sede'],


          },

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'zone',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Zone',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "produttore_IdZona_Sede", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_IdZona_Sede',
        hideOnEdit: true,
      },
    ]
  }
]
export const addElencoTrasportatori: AnaColumn[] = [
  {
    itemType: "group", caption: 'filtri Sede Legale', groupDataField: 'quartoGruppo', class: "p-1", colCount: 2, data: [

      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'ragioneSociale',
        //odataType:'select',
        //odataFilter:'in',
        class: 'statImpostazioni',
        nCol: 5,
        height: 230,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idTrasportatore',
        caption: 'Prod./Det',

        lista: {
          Async: false,

          dataSource: 'Soggetto',
          valueExpr: 'id',
          queryString: '?TipoAttivita=T',
          displayExpr: 'ragioneSociale',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          //tipoSelect:'odata',
          // labelSelect:'Solo causali operazioni2',
        },
      },

      {
        type: 'campo',
        dataField: 'produttore_sede',
        editorType: 'dxSelectBox',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'trasportatore_Id_Soggetto',
        labelVisible: false,
        caption: 'Produttore Sede',
        class: 'statImpostazioni',
        nCol: 5,
        height: 230,
        lista: {
          dataSource: 'Sede/GetAllSoggettiSedi',
          valueExpr: 'id',
          filter: '?$filter=( isproduttore eq true  and id gt 0)',
          queryString: '?$filter=( isTrasportatore eq true and id gt 0 and id ne null)&$orderby=Descrizione asc',
          //queryString:'?$orderby=Descrizione asc', da sistemare
          displayExpr: 'descrizione',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          tipoSelect: 'multiple',
          labelSelect: 'Sede Soggetto',
        },
      },


    ]
  },
  {
    itemType: "group", caption: 'filtri su Unità legali', groupDataField: 'produttoreGroup', class: "p-1", colCount: 2, data: [

      {
        type: 'campoSpecial', dataField: "regione_soggetto_destinatario", dataType: "", caption: "Regione Soggetto",

        colVisible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        staticDataField: 'trasportatore_Id_Regione_Soggetto',
        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",
          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|trasportatore_Id_Regione_Soggetto'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "trasportatore_Id_Regione_Soggetto", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'produttore_Id_Regione_Sede',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "trasportatore_Regione_Sede", dataType: "", caption: "Regione Sede",

        colVisible: false,
        nCol: 5,
        labelWidth: 120,
        disableOnUpdate: false,
        //staticDataField: 'trasportatore_Id_Regione_Sede',
        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",

          componentType: 'dynamicGrid',
          related: ['cap', 'siglaProvincia', 'id|trasportatore_Id_Regione_Sede'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "trasportatore_Id_Regione_Sede", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'trasportatore_Id_Regione_Sede',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "id_categoria_descrizione_trasportatore",
        dataType: "", caption: "Categorie Soggetto",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 130,
        //staticDataField: 'id_categoria_descrizione_trasportatore',
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|trasportatore_IdCategoria_Soggetto'],

          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=SOGGETTI",
          filterStatic: "",

          displayExpr: 'descrizione',
          dataSource: "Categoria",
          service: 'categoria',
          autocomplete: true,
          valueExpr: '',
          caption: "Categorie",

          searchOptions: {
            service: 'categoria',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'categoria',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Categoria',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },

      {
        type: 'campoSpecial', dataField: "trasportatore_IdCategoria_Soggetto", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'trasportatore_IdCategoria_Soggetto',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "categoria_descrizione_sedi_trasportatori",
        dataType: "", caption: "Categorie Sedi",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        staticDataField: 'trasportatore_IdCategoria_Soggetto',
        labelWidth: 120,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|trasportatore_IdCategoria_Sede'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=Sedi",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Categoria",
          service: 'categoria',
          autocomplete: true,
          valueExpr: '',
          caption: "Categorie",

          searchOptions: {
            service: 'categoria',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'categoria',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Categoria',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "trasportatore_IdCategoria_Sede", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'trasportatore_IdCategoria_Sede',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "descrizione_zona_produttori_soggetto",
        dataType: "", caption: "Zona Soggetto",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 130,
        staticDataField: 'id_descrizione_zona_trasportatori',
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|trasportatore_IdZona_Soggetto'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=SOGGETTI",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Zona",
          service: 'zona',
          autocomplete: true,
          valueExpr: '',
          caption: "Zone",

          searchOptions: {
            service: 'zone',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'zone',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Zone',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "trasportatore_IdZona_SoggettO", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'trasportatore_IdZona_Soggetto',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "descrizione_zona_produttori_sede",
        dataType: "", caption: "Zona Sedi",
        colVisible: false,
        labelVisible: true,

        nCol: 5,
        labelWidth: 120,
        staticDataField: 'id_descrizione_zona_trasportatori',
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|trasportatore_IdZona_Sede'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=Sedi",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Zona",
          service: 'zona',
          autocomplete: true,
          valueExpr: '',
          caption: "Zone",

          searchOptions: {
            service: 'zone',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'zone',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Zone',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "trasportatore_IdZona_Sede", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'trasportatore_IdZona_Sede',
        hideOnEdit: true,
      },
    ]
  }
]

export const addElencoDestinatari: AnaColumn[] = [
  {
    itemType: "group", caption: 'filtri Sede Legale', groupDataField: 'terzoGruppo', class: "p-1", colCount: 2, data: [

      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'ragioneSociale',
        //odataType:'select',
        //odataFilter:'in',
        class: 'statImpostazioni',
        nCol: 5,
        height: 230,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'idDestinatario',
        caption: 'Prod./Det',

        lista: {
          Async: false,

          dataSource: 'Soggetto',
          valueExpr: 'id',
          queryString: '?TipoAttivita=S',
          displayExpr: 'ragioneSociale',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          //tipoSelect:'odata',
          // labelSelect:'Solo causali operazioni2',
        },
      },

      {
        type: 'campo',
        dataField: 'produttore_sede',
        editorType: 'dxSelectBox',
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_Id_Soggetto',
        labelVisible: false,
        caption: 'Produttore Sede',
        class: 'statImpostazioni',
        nCol: 5,
        height: 230,
        lista: {
          dataSource: 'Sede/GetAllSoggettiSedi',
          valueExpr: 'id',
          filter: '',
          queryString: '?$filter=(isSmaltitore eq true and id gt 0 and id ne null)',
          //queryString:'?$orderby=Descrizione asc', da sistemare
          displayExpr: 'descrizione',
          static: false,
          isMultiple: true,
          showSelectionControls: false,
          tipoSelect: 'multiple',
          labelSelect: 'Sede Soggetto',
        },
      },


    ]
  },
  {
    itemType: "group", caption: 'filtri su Unità legali', groupDataField: 'produttoreGroup', class: "p-1", colCount: 2, data: [
      {
        type: 'campoSpecial', dataField: "destinatario_Regione_Soggetto", dataType: "", caption: "Regione Soggetto",

        colVisible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        //staticDataField: 'destinatario_Regione_Soggetto',
        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",

          componentType: 'dynamicGrid',
          related: ['id|destinatario_Id_Regione_Soggetto'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "destinatario_Id_Regione_Soggetto", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_Id_Regione_Soggetto',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "regione_sede_destinatario", dataType: "", caption: "Regione Sede",

        colVisible: false,
        nCol: 5,
        labelWidth: 120,
        disableOnUpdate: false,
        staticDataField: 'regione_sede_destinatario',
        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",

          componentType: 'dynamicGrid',
          related: ['id|destinatario_Id_Regione_Sede'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "destinatario_Id_Regione_Sede", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_Id_Regione_Sede',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "categoria_descrizione_soggetto_destinatari",
        dataType: "", caption: "Categorie Soggetto",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 130,
        staticDataField: 'id_categoria_destinatari',
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|destinatario_IdCategoria_Soggetto'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=SOGGETTI",
          filterStatic: "",

          displayExpr: 'descrizione',
          dataSource: "Categoria",
          service: 'categoria',
          autocomplete: true,
          valueExpr: '',
          caption: "Categorie",

          searchOptions: {
            service: 'categoria',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'categoria',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Categoria',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "destinatario_IdCategoria_Soggetto", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_IdCategoria_Sogget',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "categoria_descrizione_sedi_destinatari",
        dataType: "", caption: "Categorie Sedi",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 120,
        staticDataField: 'id_categoria_sedi_destinatari',
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|destinatario_IdCategoria_Sede'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=Sedi",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Categoria",
          service: 'categoria',
          autocomplete: true,
          valueExpr: '',
          caption: "Categorie",

          searchOptions: {
            service: 'categoria',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'categoria',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Categoria',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "destinatario_IdCategoria_Sede", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_IdCategoria_Sede',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "descrizione_zona_destinatari_soggetto",
        dataType: "", caption: "Zona Soggetto",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 130,
        staticDataField: 'id_zona_destinatari',
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|destinatario_IdZona_Soggetto'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=SOGGETTI",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Zona",
          service: 'zona',
          autocomplete: true,
          valueExpr: '',
          caption: "Zone",

          searchOptions: {
            service: 'zone',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'zone',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Zone',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "destinatario_IdZona_Soggetto", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_IdZona_Soggetto',
        hideOnEdit: true,
      },
      {
        type: 'campoSpecial', dataField: "descrizione_zona_destinatari_sede",
        dataType: "", caption: "Zona Sedi",
        colVisible: false,
        labelVisible: true,
        nCol: 5,
        labelWidth: 120,
        staticDataField: 'id_zona_sede_destinatari',
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {
          related: ['cap', 'siglaProvincia', 'id|destinatario_IdZona_Sede'],
          costantValue: [{
            key: 'id',
            value: 'id'

          }],
          queryString: "?nomeTabella=Sedi",
          filterStatic: "",
          displayExpr: 'descrizione',
          dataSource: "Zona",
          service: 'zona',

          autocomplete: true,
          valueExpr: '',
          caption: "Zone",

          searchOptions: {
            service: 'zone',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|id'],


          },

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'zone',
            location: 'after',
          },

          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridMultiple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Zone',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "destinatario_IdZona_Sede", dataType: "", caption: "Regionexxxxx",
        colVisible: false,
        class: 'd-none',
        visible: false,
        nCol: 5,
        labelWidth: 130,
        disableOnUpdate: false,
        odataType: 'select',
        odataFilter: 'in',
        staticDataField: 'destinatario_IdZona_Sede',
        hideOnEdit: true,
      },
    ]
  }
]





